import React from "react";
import { cn } from "@/lib/cn";

export interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  active?: boolean;
}

export function Chip({ active = false, className, ...rest }: ChipProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold",
        active
          ? "bg-green-tint text-green-med dark:bg-white/10 dark:text-green-bright"
          : "bg-surface text-ink-secondary border border-hairline",
        className,
      )}
      {...rest}
    />
  );
}
